import { createSelector } from 'reselect'
import { values, emptyObj } from 'util/objects'
import { emptyArr } from 'util/arrays'

export const foldersByIdSelector = state => state.folders.byId || emptyObj

export const selectOrderedFolderIds = state => state.folders.ordered || emptyArr

// Its VERY important we dont return a new object all the time from this base selector...
// FIXME: values() will return a new object all the time...
export const selectFolders = createSelector(foldersByIdSelector, byId =>
  values(byId)
)

export const selectFoldersOrdered = createSelector(
  foldersByIdSelector,
  selectOrderedFolderIds,
  (byId, ordered) => ordered.map(id => byId[id]) // FIXME - terrible perf - always creates new object.
)
